import React from 'react';
import { Formik } from 'formik';
import { localise } from '../../../../services/lang/lang';
import EditVisitDetailsForm from './EditVisitDetailsForm';
import date from '../../../../services/ui/date';
import SuspenseWrapper from '../../../modules/SuspenseWrapper/SuspenseWrapper';
import useGenericMutationUseCase from '../../../../hooks/usecases/generic/useGenericMutationUseCase';
import { useUpdateInspection } from '../../../../services/api/generated/client';
import StandardModal from '../../../modules/Modal/StandardModal';
import FormikModalErrorSync from '../../../modules/Modal/FormikModalErrorSync';
import { useUnsavedChanges } from '../../../modules/UnsavedChanges/UnsavedChangesProvider';
const EditVisitDetailsModal = ({ inspection, onClose, onSuccess, }) => {
    const initialFormValues = {
        inspection_date: date.picker(inspection.inspection_date),
        reference: inspection.reference,
    };
    const { attemptNavigate } = useUnsavedChanges();
    const editVisitDetails = useGenericMutationUseCase(useUpdateInspection);
    const doSubmit = (values, helpers) => {
        const inspectionDate = date.server(values.inspection_date);
        editVisitDetails.execute({
            inspectionId: inspection.id,
            data: {
                inspection_date: inspectionDate,
                reference: values.reference,
            },
        }, helpers, {
            onSuccess,
        });
    };
    const handleClose = () => attemptNavigate(onClose);
    return (React.createElement(StandardModal, { "data-testid": "edit_visit_details_modal__modal", variant: "primary", isOpen: true, onClose: handleClose, title: localise('EDIT_VISIT_DETAILS') },
        React.createElement(SuspenseWrapper, null,
            React.createElement(Formik, { onSubmit: doSubmit, initialValues: initialFormValues },
                React.createElement(React.Fragment, null,
                    React.createElement(FormikModalErrorSync, null),
                    React.createElement(EditVisitDetailsForm, { "data-testid": "edit_visit_details_modal__form", onClose: handleClose }))))));
};
export default EditVisitDetailsModal;
